(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.esCollectionInitialized === 'true') return;
    section.dataset.esCollectionInitialized = 'true';

    var select = section.querySelector('[data-es-collection-sort]');
    var form = section.querySelector('[data-es-collection-sort-form]');
    if (!select || !form) return;

    select.addEventListener('change', function () {
      form.submit();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-es-main-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
